export const areWalletsEqual = (wallet1: string, wallet2: string): boolean =>
    wallet1.toLowerCase() === wallet2.toLowerCase();

export const createLinkName = (title: string, prefix: string = "#", name: string = "item"): string =>
    `${prefix}${name}-${title.replace(" ", "-").replace(":", "-").replace(" ", "-").trim().toLocaleLowerCase()}`;
